"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domain = exports.gardenApi = void 0;
exports.gardenApi = "gardenRApi";
exports.domain = "roam.garden";